import React from "react";
import "./StatsHeader.css";
import Flex from "../../../../components/Flex/Flex";
import { useDispatch, useSelector } from "react-redux";
import {
  selectCustomDateFilterValue,
  selectDateFilterValue,
  selectLimitFilterValue,
  selectPlayerToShowStats,
  selectTableSizeFilterValue,
} from "../../selectors";
import Text from "../../../../components/Text/Text";
import {
  changeDateFilter,
  changeLimitFilter,
  changeTableSizeFilter,
  dropFilters,
  findStats,
} from "../../actions";
import TableSizeFilter from "../../../../components/TableSizeFilter/TableSizeFilter";
import LimitFilter from "../../../../components/LimitFilter/LimitsFilter";
import DateFilter, {
  CustomDateFilterValue,
} from "../../../../components/DateFilter/DateFilter";

const StatsHeader = React.memo(() => {
  const dispatch = useDispatch();

  const playerToShowStats = useSelector(selectPlayerToShowStats);

  const tableSizeFilterValue = useSelector(selectTableSizeFilterValue);
  const limitFilterValue = useSelector(selectLimitFilterValue);
  const dateFilterValue = useSelector(selectDateFilterValue);
  const customDateFilterValue = useSelector(selectCustomDateFilterValue);

  const handleChangeTableSizeFilter = React.useCallback(
    (value?: number) => {
      dispatch(changeTableSizeFilter(value));
    },
    [dispatch]
  );

  const handleChangeLimitFilter = React.useCallback(
    (value: number) => {
      dispatch(changeLimitFilter(value));
    },
    [dispatch]
  );

  const handleChangeDateFilter = React.useCallback(
    (value?: number, customValue?: CustomDateFilterValue) => {
      dispatch(changeDateFilter({ value, customValue }));
    },
    [dispatch]
  );

  const handleSearchWithoutFilters = React.useCallback(() => {
    dispatch(dropFilters());
    dispatch(
      findStats({
        playername: playerToShowStats.playername,
        pokersiteId: playerToShowStats.pokersiteId,
      })
    );
  }, [dispatch, playerToShowStats]);

  return (
    <Flex
      className="StatsHeader"
      justify="space-between"
      align="center"
    >
      <Flex
        gap={24}
        align="center"
      >
        <Flex
          className="StatsHeader__Site"
          justify="center"
          align="center"
          onClick={handleSearchWithoutFilters}
        >
          <Text
            type="secondary"
            size={3}
          >
            {playerToShowStats.pokersitePostfix}
          </Text>
        </Flex>
        <Text
          bold
          size={6}
          className="StatsHeader__PlayerName"
        >
          {playerToShowStats.playername}
        </Text>
      </Flex>
      <Flex
        gap={16}
        className="StatsHeader__Filters"
      >
        <TableSizeFilter
          value={tableSizeFilterValue}
          onChange={handleChangeTableSizeFilter}
        />

        <LimitFilter
          value={limitFilterValue}
          onChange={handleChangeLimitFilter}
        />

        <DateFilter
          value={dateFilterValue}
          customValue={customDateFilterValue}
          onChange={handleChangeDateFilter}
        />
      </Flex>
    </Flex>
  );
});

export default StatsHeader;
